import * as Scrivito from "scrivito";
import {
  getFormatLabel,
  getCategoryLabel,
  isExpiredCourse,
} from "../TrainingCoursePage/_trainingUtils";
import { AvailabilityBadge } from "../TrainingCoursePage/AvailablityBadge";
import { createTranslator } from "../../utils/translate";
import de from "./de.json";
import en from "./en.json";

const translations = { de, en };

const formatTableDate = (dt) => {
  if (!dt) return "—";
  return dt.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const TrainingCourseRow = Scrivito.connect(({ course, language }) => {
  const expired = isExpiredCourse(course);
  const t = createTranslator(language, translations);

  return (
    <tr style={expired ? { opacity: 0.45 } : undefined}>
      <td data-label={t("date")}>{formatTableDate(course.get("startDate"))}</td>
      <td data-label={t("category")}>
        {(course.get("category") || []).map((k) => (
          <span key={k} className="badge rounded-pill bg-blue me-1">
            {getCategoryLabel(k, language)}
          </span>
        ))}
      </td>
      <td data-label={t("course")}>{course.get("title") || "—"}</td>
      <td data-label={t("format")}>
        <span
          className={`badge ${
            course.get("format") === "online" ? "bg-teal" : "bg-blue"
          } --outline`}
        >
          {getFormatLabel(course.get("format"), language)}
        </span>
      </td>
      <td data-label={t("location")}>{course.get("location") || "—"}</td>
      <td data-label={t("freeSlots")}>
        <AvailabilityBadge course={course} language={language} />
      </td>
      <td data-label={t("action")} className="text-end">
        <Scrivito.LinkTag to={course} className="btn bg-blue btn-sm">
          {t("learnMore")}
        </Scrivito.LinkTag>
      </td>
    </tr>
  );
});

export default TrainingCourseRow;
